/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * When student submitted the module (if applicable)
 */
export type StudentProgressRecordModuleSubmissionDate = string | null;
